var _style, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileFirstLayoutsResponsivos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Camada_1",
    x: 0,
    y: 0,
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#031326}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce87ea",
    d: "M38.9 4.7L11.1 14.8v27.9l27.8-10.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e097fb",
    d: "M37.3 3.5H12.7c-.9 0-1.6.6-1.6 1.4v10.9L38.9 5.7v-.8c0-.8-.7-1.4-1.6-1.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 48.8H12.7c-1.6 0-2.9-1.2-2.9-2.7V3.9c0-1.5 1.3-2.7 2.9-2.7h24.6c1.6 0 2.9 1.2 2.9 2.7v42.2c0 1.5-1.3 2.7-2.9 2.7zM12.7 3.7c-.2 0-.4.1-.4.2v42.2s.1.2.4.2h24.6c.2 0 .4-.1.4-.2V3.9s-.1-.2-.4-.2H12.7z",
    className: "st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1 45.3H14.9c-.9 0-1.6-.7-1.6-1.5V6.2c0-.8.7-1.5 1.6-1.5h20.2c.9 0 1.6.7 1.6 1.5v37.6c0 .8-.7 1.5-1.6 1.5zM14.9 5.2c-.6 0-1.1.4-1.1 1v37.6c0 .6.5 1 1.1 1h20.2c.6 0 1.1-.5 1.1-1V6.2c0-.6-.5-1-1.1-1H14.9z",
    className: "st2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 10h19.3v5.7H15.4zm0 27.6h19.3v5.7H15.4zm0-19.9h19.3v18H15.4zm11.2-10h-3.1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.1c.3 0 .5.2.5.5s-.3.5-.5.5z",
    className: "st2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFirstLayoutsResponsivos);
export default __webpack_public_path__ + "static/media/mobile-first-layouts-responsivos.04dfc712ad2828d37ac3ab8a110dbb9a.svg";
export { ForwardRef as ReactComponent };